<template>
    <div id="loading" v-if="loading">
        <img src="@/assets/images/template/loading.gif"/>
        <span>{{text}}</span>
    </div>
</template>

<script>
    export default {
        name: "loading",
        data() {
            return {
                loading: false,
                text:this.$t('trade.loading'),
            }
        },
        created() {
            this.$bus.$on('loading', (data,text) => {
                this.loading = !data;
                if (text != null && text != "") this.text = text;
                else this.text = this.$t('trade.loading');
            })
        },
        beforeDestroy() {
            this.$bus.$off('loading', (data,text) => {
                this.loading = data;
                if (text != null && text != "") this.text = text;
                else this.text = this.$t('trade.loading');
            })
        }
    }
</script>
